<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-card class="grey lighten-3">
    <v-toolbar color="primary" dark dense>
      <v-btn icon text @click="close()">
        <v-icon small>arrow_back_ios</v-icon>
      </v-btn>
      <div class="text-h6">Audio Insights</div>
      <v-spacer></v-spacer>
      <v-btn icon text @click="close()">
        <v-icon small>clear</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-container class="fill-height">
        <v-row v-if="loadingInsights || !insights">
          <v-col class="text-center" cols="12" >
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12" md="6" lg="6">
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title class="justify-center font-weight-bold">
                    <span>Duración del audio</span>
                    <v-spacer></v-spacer>
                    <v-chip class="ma-2" :x-large="true">
                      <v-icon left>schedule</v-icon>
                      {{duration}}
                    </v-chip>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card>
                  <v-card-title class="justify-center font-weight-bold">
                    <span>Agente</span>
                    <v-spacer></v-spacer>
                    <v-chip class="ma-2" :x-large="true">
                      <v-icon left>perm_identity</v-icon>
                      {{agent}}
                    </v-chip>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card>
                  <v-card-title class="justify-center font-weight-bold">
                    <span>Fecha</span>
                    <v-spacer></v-spacer>
                    <v-chip class="ma-2" :x-large="true">
                      <v-icon left>date_range</v-icon>
                      {{date}}
                    </v-chip>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col cols="12" v-if="insights.conversation || insights.full_conversation_transcript">
                <v-card style="height: 400px;">
                  <v-card-title class="justify-center font-weight-bold">Guión de la conversación</v-card-title>
                  <v-divider class="mx-4"></v-divider>
                  <v-card-text style="height: 345px; overflow-y: scroll;">
                    <template v-for="(item, index) in insights.conversation.script">
                      <transition
                        appear
                        name="message"
                        :duration="{ enter: 5000 }"
                        :key="index + 'list'"
                        :enter-active-class="`message-enter-${(index%2)}`"
                        leave-active-class="rollout"
                      >
                        <!--
                        <v-list
                          two-line
                          class="pa-0 message scroll-y"
                          :style="index < 6 ? `transition-delay: ${index/2}s` : ''"
                        >
                          <v-list-item>
                            <v-list-item-action>
                              <v-icon large color="primary">people</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>{{item.character}}</v-list-item-title>
                              <v-list-item-subtitle v-html="item.text"></v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        -->
                        <v-card class="my-2" :style="index < 6 ? `transition-delay: ${index/2}s` : ''">
                          <v-card-text>
                            <v-row>
                              <v-col class="shrink" >
                                <v-icon large color="primary">people</v-icon>
                              </v-col>
                              <v-col class="shrink" >
                                <v-card text>
                                  <v-card-title class="py-1"><strong>{{item.character}}</strong></v-card-title>
                                  <v-card-text class="py-1" v-html="item.text" />
                                </v-card>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </transition>
                      <v-divider
                        v-if="index + 1 < insights.conversation.script.length"
                        :key="index + 'div'"
                      ></v-divider>
                    </template>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6" lg="6" v-if="dominanceData">
            <v-card class="fill-height">
              <v-card-title class="justify-center font-weight-bold">Dominancia de la conversación</v-card-title>
              <v-divider class="mx-4"></v-divider>
              <v-card-text>
                <Chart :options="dominanceData" />
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" lg="6" v-if="insights.conversation">
            <v-card>
              <v-card-title class="justify-center font-weight-bold">Conversación</v-card-title>
              <v-divider class="mx-4"></v-divider>
              <v-card-text>
                <Chart
                  :options="{
                                  chart: {
                                    plotBackgroundColor: null,
                                    plotBorderWidth: null,
                                    plotShadow: false,
                                    type: 'pie'
                                  },
                                  title: {
                                    text: ''
                                  },
                                  subtitle: {
                                    // text: `Del total de audio ${insights.conversation.time.silent} segundos son de silencio y ${insights.conversation.time.speaking} de conversación real entre asesor y usuario`
                                  },
                                  tooltip: {
                                    pointFormat: '{series.name}: <b>{point.y}</b>'
                                  },
                                  plotOptions: {
                                    pie: {
                                      allowPointSelect: true,
                                      cursor: 'pointer',
                                      dataLabels: {
                                        enabled: true,
                                        format: '<b>{point.name}</b> {point.percentage:.1f} %',
                                        style: {
                                          color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                                        }
                                      }
                                    }
                                  },
                                  series: [{
                                    name: 'Silencios',
                                    colorByPoint: true,
                                    data: [{
                                      name: 'Silencio',
                                      y: insights.conversation.time.silent,
                                      sliced: true,
                                      selected: true,
                                      color: '#d13f2b'
                                    }, {
                                      name: 'Hablando',
                                      y: insights.conversation.time.speaking,
                                      color: 'rgb(65, 168, 128)'
                                    }]
                                  }],
                                  credits: false
                                }"
                />
              </v-card-text>
            </v-card>
          </v-col>
          <v-col v-if="insights.rating">
            <v-card>
              <v-card-title class="font-weight-bold">
                Calificación
                <v-spacer></v-spacer>
                <v-icon :color="insights.rating < 3.5 ? 'deep-orange darken-1' : 'green'">mdi-star</v-icon>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row class="ma-0"   >
                  <v-col class="text-center" cols="12" >
                    <v-progress-circular
                      :color="insights.rating < 3.5 ? 'deep-orange darken-1' : 'green'"
                      :rotate="-90"
                      :size="100"
                      :width="15"
                      :value="100"
                    >{{insights.rating.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}}</v-progress-circular>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" lg="6" v-if="insights.sentimental">
            <v-card>
              <v-card-title class="justify-center font-weight-bold">Sentimiento de la conversación</v-card-title>
              <v-divider class="mx-4"></v-divider>
              <v-card-text>
                <Chart :options="sentimentalData" />
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" v-if="insights.wordcloud">
            <v-card>
              <v-card-title class="justify-center font-weight-bold">WordCloud</v-card-title>
              <v-divider class="mx-4"></v-divider>
              <v-card-text>
                <v-container class="fill-height" fluid >
                  <VueWordCloud
                    style="min-width: 400px; min-height: 400px;"
                    :words="insights.wordcloud"
                    :rotation="rotateWord"
                    rotation-unit="deg"
                    :color="setWordColor"
                    font-family="Roboto"
                  />
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import Highcharts from 'highcharts'
import More from 'highcharts/highcharts-more'
import HighchartsVue, { Chart } from 'highcharts-vue'
import VueWordCloud from 'vuewordcloud'
// import sandTheme from 'highcharts/themes/sand-signika'
More(Highcharts)
// sandTheme(Highcharts)
// Apply more-highcharts
Vue.use(HighchartsVue)
export default {
  created () {
    console.log('this.insight')
    console.log(this.insights)
  },
  components: { Chart, [VueWordCloud.name]: VueWordCloud },
  computed: {
    ...mapState({
      insights: state => state.speech.selectedAudioTranscript.insights,
      duration: state => state.speech.selectedAudioTranscript.duration,
      agent: state => state.speech.selectedAudioTranscript.agent,
      sentimentalData () {
        const colors = [
          'rgb(144, 237, 125)',
          'rgba(0, 102, 204, 0.34)',
          'rgba(222, 43, 25, 0.87)'
        ]
        const sentimentalSeries = []
        if (this.insights.sentimental) {
          for (let i = 0; i < this.insights.sentimental.length; i++) {
            sentimentalSeries.push({
              name: this.insights.sentimental[i].name,
              data: [this.insights.sentimental[i].count],
              color: colors[i % colors.length]
            })
          }
        }
        const sentimentalData = {
          chart: {
            type: 'column'
          },
          title: {
            text: ''
          },
          xAxis: {
            categories: ['Sentimiento']
          },
          yAxis: {
            min: 0,
            title: {
              text: 'Reacciones'
            }
          },
          tooltip: {
            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
            shared: true
          },
          plotOptions: {
            column: {
              stacking: 'percent'
            }
          },
          series: sentimentalSeries,
          credits: false
        }
        return sentimentalData
      },
      dominanceData () {
        if (
          !this.insights.dominance ||
          this.insights.dominance.advisor === undefined ||
          this.insights.dominance.client === undefined
        ) {
          return false
        }
        return {
          chart: {
            type: 'column',
            height: '580px'
          },
          title: {
            text: ''
          },
          xAxis: {
            categories: ['Interlocutor']
          },
          yAxis: {
            min: 0,
            title: {
              text: 'Total de la conversación'
            }
          },
          tooltip: {
            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
            shared: true
          },
          plotOptions: {
            column: {
              stacking: 'percent'
            }
          },
          series: [
            {
              name: 'Agente',
              data: [this.insights.dominance.advisor]
            },
            {
              name: 'Cliente',
              data: [this.insights.dominance.client]
            }
          ],
          credits: false
        }
      }
    })
  },
  data () {
    return {
      Highcharts
    }
  },
  methods: {
    rotateWord ([, weight]) {
      const rotation = [0, 45, 90, 315]
      return rotation[Math.floor(Math.random() * 4)]
      // return rotation[weight % rotation.length]
    },
    setWordColor ([, weight]) {
      const colors = [
        'rgb(95, 216, 100)',
        'rgb(62, 66, 202)',
        'rgb(42, 195, 195)',
        'rgb(195, 183, 42)',
        'rgb(95, 216, 100)',
        'RoyalBlue',
        'Indigo'
      ]
      return colors[weight % colors.length]
    },
    close () {
      this.$emit('cancel')
    }
  },
  props: {
    // insights: {
    //   type: Object
    // },
    // duration: {
    //   type: String
    // },
    // agent: {
    //   type: String
    // },
    date: {
    },
    loadingInsights: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style lang="scss" scoped>
@mixin listdesp($xaxis: 0) {
  transform: translateX($xaxis);
}
.message {
  transition-property: all;
  transition-duration: 0.5s;
  transition-timing-function: ease;
}
.message-enter-0 {
  @include listdesp(-500px);
}
.message-enter-1 {
  @include listdesp(500px);
}
.message-enter-to {
  @include listdesp(0);
}
</style>
